export default __webpack_public_path__ + "static/media/schedule-colored-icon.6dc99a60.svg";